module.exports = __webpack_public_path__ + "static/media/photoshoot-3.bab08c46.jpg";